module.exports = __webpack_public_path__ + "static/banner-c8d181ba65f2192c94bbdea08c53eadb.png";